import React from 'react';

import {formatPrice, getCurrencySymbol} from 'utils/currency';
import {getUnitPerProduct} from 'utils/product';

import {StyledPerUnitPriceText} from './styles';

type WeightedFreshPriceProps = {
  perUnitPrice?: number;
  size: string;
  isWeightedFreshV3Enabled?: boolean;
};

export const WeightedFreshPerUnitPrice: React.FC<WeightedFreshPriceProps> = ({
  perUnitPrice,
  size,
  isWeightedFreshV3Enabled
}: WeightedFreshPriceProps): JSX.Element | null => {
  const productPrice = formatPrice(perUnitPrice);
  const unitDescription = getUnitPerProduct(size || '', true, isWeightedFreshV3Enabled);
  const currencySymbol = getCurrencySymbol();

  return (
    <StyledPerUnitPriceText display={'block'} variant="caption" color="text.secondary">
      {productPrice} {currencySymbol} {unitDescription}
    </StyledPerUnitPriceText>
  );
};
